const photoModules = import.meta.glob('./img-*.{jpg,png}', { eager: true, import: 'default' }) as Record<string, string>;

export const strasniceImages: string[] = Object.entries(photoModules)
  .sort(([a], [b]) => {
    const na = parseInt(a.match(/img-(\d+)/)?.[1] || "0");
    const nb = parseInt(b.match(/img-(\d+)/)?.[1] || "0");
    return na - nb;
  })
  .map(([, src]) => src);
